import axiosInstance from '../config/axios.js';

const API_BASE = '/company-whatsapp-counter';

const whatsappCounterService = {
  // ==================== Counter Operations ====================
  
  // Get counter by company ID
  getByCompany: async (companyId) => {
    const response = await axiosInstance.get(`${API_BASE}/${companyId}`);
    return response.data;
  },

  // Get all counters (System Admin only)
  getAll: async () => {
    const response = await axiosInstance.get(`${API_BASE}/all`);
    return response.data;
  },

  // Get overall statistics (System Admin only)
  getStatistics: async () => {
    const response = await axiosInstance.get(`${API_BASE}/statistics`);
    return response.data;
  },

  // Get my company's counter
  getMyCounter: async () => {
    const response = await axiosInstance.get(`${API_BASE}/my-counter`);
    return response.data;
  },

  // Get pending payments (companies with due)
  getPendingPayments: async () => {
    const response = await axiosInstance.get(`${API_BASE}/pending-payments`);
    return response.data;
  },

  // Update cost per message (System Admin only) — applies one rate to every category
  updateCostPerMessage: async (companyId, costPerMessage) => {
    const response = await axiosInstance.put(`${API_BASE}/${companyId}/cost-per-message`, {
      cost_per_message: costPerMessage
    });
    return response.data;
  },

  // Category rates (excl. GST) and GST percent. Recalculates the current bill.
  updateBillingRates: async (companyId, rates) => {
    const response = await axiosInstance.put(`${API_BASE}/${companyId}/billing-rates`, rates);
    return response.data;
  },

  // Reset counter (System Admin only)
  resetCounter: async (companyId, retainFinancials = false) => {
    const response = await axiosInstance.post(`${API_BASE}/${companyId}/reset`, {
      retain_financials: retainFinancials
    });
    return response.data;
  },

  // Download invoice PDF
  downloadInvoice: async (companyId, includePayments = false) => {
    const response = await axiosInstance.get(`${API_BASE}/${companyId}/invoice`, {
      params: {
        include_payments: includePayments
      },
      responseType: 'blob'
    });
    return response.data;
  },

  // Email WhatsApp usage invoice PDF to company email
  sendInvoiceEmail: async (companyId, includePayments = true) => {
    const response = await axiosInstance.post(`${API_BASE}/${companyId}/invoice/send`, {
      include_payments: includePayments,
    });
    return response.data;
  },

  // ==================== Utility Functions ====================

  // Format currency for display
  formatCurrency: (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(amount || 0);
  },

  // Format date for display
  formatDate: (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  }
};

export default whatsappCounterService;
